import { render } from "./App.vue?vue&type=template&id=7ba50f4c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=7ba50f4c&lang=postcss"
script.render = render

export default script